
import Link from '@/components/Link';
import { cls } from 'tagged-classnames-free';
export const SameAs: React.FC = () => {
  return (
    <div className='flex items-center gap-4'>
      {[
        {
          icon: 'i-com--logo-twitter-color',
          href: 'https://x.com/TadAI_official',
        },
        {
          icon: 'i-com--logo-facebook-color',
          href: 'https://www.facebook.com/tadaimusic',
        },
        {
          icon: 'i-com--logo-tiktok-color',
          href: 'https://www.tiktok.com/@tadai_official',
        },
        {
          icon: 'i-com--logo-youtube-color',
          href: 'https://www.youtube.com/@TadAI-official',
        },
        {
          icon: 'i-com--logo-instagram-color',
          href: 'https://www.instagram.com/tadai_official/',
        },
      ].map((item) => {
        return (
          <Link key={item.icon} href={item.href} rel='nofollow' target='_blank'>
            <span
              className={cls`${item.icon} block size-6 opacity-35 hover:opacity-100`}
            ></span>
          </Link>
        )
      })}
    </div>
  )
}
